export default "__VITE_ASSET__xcQeGvgW__"